import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { withStyles, Theme } from '@material-ui/core/styles';
import { green } from '@material-ui/core/colors';
import { Grid, Typography } from '@material-ui/core';
import MenuPage from '../MenuPage';

const styles = (theme: Theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    width: '100%',
  },
  fabGreen: {
    marginLeft: '10%',
    color: theme.palette.common.white,
    backgroundColor: green[500],
    boxShadow: 'none',
  },
});

const BackupMain: React.FC<{ classes: any }> = ({ classes }) => {
  const { t } = useTranslation();

  const options = [
    {
      icon: 'backup',
      text: t('title.backup.createBackup'),
      link: '/backup/create',
    },
    {
      icon: 'restore',
      text: t('title.backup.restoreBackup'),
      link: '/backup/restore',
    },
  ];

  return (
    <Grid
      container
      justify="center"
      className={[classes.root, classes.centerContainer].join(' ')}
    >
      <div style={{ textAlign: 'center' }}>
        <Typography style={{ fontSize: '32px' }} variant="overline">
          <Trans>title.backup.header</Trans>
        </Typography>
      </div>
      <Grid item xs={12}>
        <MenuPage options={options} />
      </Grid>
    </Grid>
  );
};

export default withStyles(styles, { withTheme: true })(BackupMain);
